import React, { useEffect, useState } from "react";
import { usePhrase } from "@/contexts/LanguageContext";
import { api, formatINR } from "@/lib/api";
import { DisclaimerBanner } from "@/components/DisclaimerBanner";

export default function Policies() {
  const pt = usePhrase();
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/lender-policies").then((r) => setItems(r.data)); }, []);
  return (
    <div className="space-y-6" data-testid="policies-page">
      <div>
        <h1 className="text-3xl font-bold text-slate-900 brand-heading">{pt("Credit Policies")}</h1>
        <p className="text-slate-600 mt-1 text-sm">{pt("Policies that drive opportunity matching. Not visible to borrowers.")}</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map((p) => (
          <div key={p.id} className="p-6 rounded-lg border border-slate-200 bg-white card-hover" data-testid={`policy-${p.id}`}>
            <div className="font-semibold text-slate-900 brand-heading">{pt(p.name)}</div>
            <div className="text-xs text-slate-500">{pt(p.product)}</div>
            <div className="mt-3 grid grid-cols-2 gap-2 text-xs">
              <div><span className="text-slate-500">{pt("Ticket:")}</span> {formatINR(p.min_loan_amount)} – {formatINR(p.max_loan_amount)}</div>
              <div><span className="text-slate-500">{pt("Vintage:")}</span> ≥ {p.min_business_vintage_years} yr</div>
              <div><span className="text-slate-500">{pt("Turnover ≥")}</span> {formatINR(p.min_annual_turnover)}</div>
              <div><span className="text-slate-500">{pt("Min DSCR:")}</span> {p.min_indicative_dscr}</div>
              <div><span className="text-slate-500">{pt("GST:")}</span> {p.gst_mandatory ? pt("Mandatory") : pt("Optional")}</div>
              <div><span className="text-slate-500">{pt("Collateral:")}</span> {p.collateral_mandatory ? pt("Mandatory") : pt("Optional")}</div>
              <div><span className="text-slate-500">{pt("CGTMSE:")}</span> {p.cgtmse_available ? pt("Available") : pt("—")}</div>
              <div><span className="text-slate-500">{pt("TAT:")}</span> {p.turnaround_days} {pt("days")}</div>
            </div>
          </div>
        ))}
        {items.length === 0 && <div className="text-sm text-slate-500">{pt("No policies configured.")}</div>}
      </div>
      <DisclaimerBanner compact />
    </div>
  );
}
